"use client";

import { useAuth } from "@clerk/nextjs";
import { useInfiniteCityMatchedCards } from "modules/city/hooks/useInfiniteCityMatchedCards";
import { formatNumber } from "utils/currency";

interface CityHubMatchSummaryProps {
  latitude: string;
  longitude: string;
}

export function CityHubMatchSummary({
  latitude,
  longitude,
}: CityHubMatchSummaryProps) {
  const { isLoaded, isSignedIn } = useAuth();
  const { currentCount, hasNextPage, isPending, isError } =
    useInfiniteCityMatchedCards({
      latitude,
      longitude,
      page: 1,
      perPage: 1,
    });

  if (!isLoaded) {
    return (
      <p className="text-base-content/55 text-sm">Checking your matches…</p>
    );
  }

  if (!isSignedIn) {
    return (
      <p className="text-base-content/55 text-sm">
        Sign in to see your matches in this city
      </p>
    );
  }

  if (isPending) {
    return (
      <p className="text-base-content/55 text-sm">Checking your matches…</p>
    );
  }

  if (isError) {
    return <p className="text-base-content/55 text-sm">Matches unavailable</p>;
  }

  if (currentCount === 0) {
    return (
      <p className="text-base-content/55 text-sm">
        Add haves and wants to start matching
      </p>
    );
  }

  const countLabel = hasNextPage
    ? `${formatNumber(currentCount)}+`
    : formatNumber(currentCount);

  return (
    <p className="flex items-baseline gap-2">
      <span className="text-2xl font-semibold tabular-nums">{countLabel}</span>
      <span className="text-base-content/55 text-sm">
        {!hasNextPage && currentCount === 1 ? "match" : "matches"}
      </span>
    </p>
  );
}
